import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import type { InventoryLocation, InventoryLot } from '@jupi/shared'
import { EMPTY_LOT, LotFields, draftToLot, lotProblem, lotToDraft, type LotDraft } from './LotFields'

// Add stock to an item, or edit one lot.
export function LotDialog({
  open,
  lot,
  locations,
  showSerial,
  saving,
  onSave,
  onClose,
}: {
  open: boolean
  lot: InventoryLot | null
  locations: InventoryLocation[]
  showSerial: boolean
  saving: boolean
  onSave: (draft: LotDraft) => void
  onClose: () => void
}) {
  const { t } = useTranslation()
  const [draft, setDraft] = useState<LotDraft>(EMPTY_LOT)
  useEffect(() => {
    if (open) setDraft(lot ? lotToDraft(lot) : EMPTY_LOT)
  }, [open, lot])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t(lot ? 'inventory.editLot' : 'inventory.addLot')}</DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: 8 }}>
          <LotFields draft={draft} onChange={setDraft} locations={locations} showSerial={showSerial} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="contained" disabled={saving || lotProblem(draft) !== null} onClick={() => onSave(draft)}>
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export { draftToLot }
